"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = exports.NOTIF_DATETIMES = exports.NOTIF_BOOLEANS = void 0;
const moment = require("moment");
const uniqid = require("uniqid");
exports.NOTIF_BOOLEANS = [
    "isSeen", "isRead"
];
exports.NOTIF_DATETIMES = [
    "publishedAt", "updatedAt"
];
const imageFields = [
    "logo"
];
class Notification {
    constructor(data) {
        this.id = null;
        this.type = null;
        this.isSeen = false;
        this.isRead = false;
        this.publishedAt = null;
        this.logo = null;
        this.source = 'https://360medics.com/';
        this.title = null;
        this.subtitle = null;
        this.tagline = null;
        if (data) {
            this.hydrate(data);
        }
    }
    hydrate(data) {
        for (const prop in data) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                if (imageFields.includes(prop)) {
                    let value = data[prop] ? `${data[prop].split('?d=')[0]}?d=${uniqid()}` : null;
                    this[prop] = value;
                }
                else {
                    let value = data[prop];
                    if (exports.NOTIF_BOOLEANS.indexOf(prop) > -1) {
                        value = Notification.toBoolOrNull(value);
                    }
                    this[prop] = value;
                }
            }
            if (prop === 'updatedAt') {
                if (typeof data[prop] === "number") {
                    this.publishedAt = parseInt(`${data[prop]}`);
                }
                else {
                    try {
                        const datetime = moment(data[prop]);
                        if (!datetime.isValid()) {
                            this.publishedAt = null;
                        }
                        else {
                            this.publishedAt = (datetime.valueOf() / 1000);
                        }
                    }
                    catch (e) {
                        this.publishedAt = null;
                    }
                }
            }
        }
    }
    static toBoolOrNull(value) {
        if (value === null) {
            return null;
        }
        switch (`${value}`.toLowerCase().trim()) {
            case "true":
            case "yes":
            case "1": return true;
            case "false":
            case "no":
            case "0":
            case null: return false;
            default: return Boolean(value);
        }
    }
}
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map